/**
 * In Case we wanted to replace axios with other request client make sure to
 * replace it here.
 *
 * Alse make sure to implement request cancellable token with modules
 * - @shared/services/main/request/tokens
 */

import { InterceptorWrapper } from '@shared/services/main/request-clients/intercepter-wrapper';
import {default as ActiveRequestClient} from  '@shared/services/main/request-clients/axios';

const RequestClient = InterceptorWrapper(ActiveRequestClient);

export default RequestClient;
